import { Typography } from '@mui/material'
import { parseLabel } from '../parseLabel'
import './FormTypography.scss'

export const FormHelptext = ({ helpText }) => {
  if (!helpText) {
    return <div />
  }

  return (
    <Typography
      className='form-help-text'
    >
      {parseLabel(helpText)}
    </Typography>
  )
}
